import { Button } from '@mui/material';
import { getGridStringOperators, GridColDef } from '@mui/x-data-grid-pro';

import { excludeValues } from '@/components/DataGrid/utils';
import {
  Disposition,
  DispositionFriendlyNames,
  ProcessType,
  ProcessTypeFriendlyNames,
} from '@/models';
import { formatDateOnly } from '@/utils/datetime';

const number = (): Partial<GridColDef> => ({
  field: 'recordNumber',
  renderCell: (params) => {
    return params.row.recordNumber;
  },
  filterOperators: getGridStringOperators().filter(
    excludeValues(['isAnyOf', 'isNotEmpty', 'isEmpty']),
  ),

  sortComparator: (a, b) =>
    (a?.toLowerCase() || '').localeCompare(b?.toLowerCase() || ''),
});

const processType = (): Partial<GridColDef> => ({
  field: 'processType',
  renderCell: (params) => {
    return (
      ProcessTypeFriendlyNames[params.row.processType as ProcessType] ||
      'No Process Type'
    );
  },
});

const disposition = (): Partial<GridColDef> => ({
  field: 'disposition',
  renderCell: (params) => {
    return (
      DispositionFriendlyNames[params.row.disposition as Disposition] ||
      'No Disposition'
    );
  },
});

const dateIssued = (): Partial<GridColDef> => ({
  field: 'createdAt',
  renderCell: (params) => formatDateOnly(params.row.dateIssued) || '/',
});

const actions = (
  navigate?: (path: string) => void,
  hasViewRole?: boolean,
): Partial<GridColDef> => ({
  sortable: false,
  filterable: false,
  renderCell: (params) => (
    <Button
      variant="text"
      disabled={!hasViewRole}
      onClick={() => {
        navigate?.('/tools/wanted-person/view/' + params.row._id);
      }}
    >
      Link to full record
    </Button>
  ),
});

export const wantedPersonRecords = (
  navigate?: (path: string) => void,
  hasViewRole?: boolean,
) => {
  return {
    number,
    processType,
    disposition,
    dateIssued,
    actions: () => actions(navigate, hasViewRole),
  };
};
